import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { baseUrl } from '../../constants';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private apiUrl = `${baseUrl}permissions`;

  constructor(private http: HttpClient) {}

  getPermissions(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl);
  }

  createPermission(permission: any): Observable<any> {
    return this.http.post(this.apiUrl, permission);
  }

  getRolePermissions(roleId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/role/${roleId}`);
  }

  assignToRole(roleId: string, permissionIds: number[]): Observable<any> {
    return this.http.post(`${this.apiUrl}/assign`, { roleId, permissionIds });
  }
  
}
